import React from 'react';
import * as RadixForm from '@radix-ui/react-form';
import { useSiteData } from '@context';
import type { DataContextProps } from '@context';

export interface FieldDetails {
  label: string;
  type: string;
  name: string;
  required: boolean;
  valueMissing?: string;
  typeMismatch?: string;
}

/**
 * Form Field.
 */
const FormField: React.FC<{ fieldDetails: FieldDetails }> = ({
  fieldDetails,
}) => {
  const { label, valueMissing, typeMismatch, type, name, required } =
    fieldDetails;
  const { siteData }: DataContextProps = useSiteData();
  const translationKey = label.toLowerCase().replace(/\s|-/g, '_');
  const translatedLabel = siteData?.translations?.[translationKey];
  return (
    <RadixForm.Field className="form-field-group" name={name}>
      <RadixForm.Label className={`form-label ${required ? 'required' : ''}`}>
        {translatedLabel ?? label}
      </RadixForm.Label>
      <RadixForm.Control asChild>
        {type === 'textarea' ? (
          <textarea
            required={required}
            rows={5}
            placeholder={translatedLabel ?? label}
            className="form-field"
          />
        ) : (
          <input
            type={type}
            required={required}
            placeholder={translatedLabel ?? label}
            className="form-field"
          />
        )}
      </RadixForm.Control>
      <div className="form-message-container">
        {valueMissing && (
          <RadixForm.Message className="form-message" match="valueMissing">
            {valueMissing}
          </RadixForm.Message>
        )}
        {typeMismatch && (
          <RadixForm.Message className="form-message" match="typeMismatch">
            {typeMismatch}
          </RadixForm.Message>
        )}
      </div>
    </RadixForm.Field>
  );
};
export default FormField;
